module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-05.0a9ebc21.png";